import React, { Component } from "react";
import { queryserviceobject } from "../../services/crudservice";
import { app } from "../..";
import {
  Label,
  Grid,
  Table,
  Button,
  Input,
  Icon,
  Segment,
  Divider
} from "semantic-ui-react";
import "../customerinfo/custinfo.css";
import { genexceldownload } from "../../services/fileanddownloads";
import moment from "moment";
class Payroll extends Component {
  constructor() {
    super();
    this.state = {
      startdate: null,
      enddate: null
    };
  }
  componentDidMount() {
    queryserviceobject("reports", { report: "payroll" });
  }
  gentable(data) {
    if (data && data.length) {
      return data.map(empdata => {
        return (
          <Table.Row error={empdata.totalhours === 0}>
            <Table.Cell>{empdata.empnumber}</Table.Cell>
            <Table.Cell>{empdata.empname}</Table.Cell>
            <Table.Cell>{empdata.regularhours}</Table.Cell>
            <Table.Cell>{empdata.ptohours}</Table.Cell>
            <Table.Cell>{empdata.unpaidhours}</Table.Cell>
            <Table.Cell>{empdata.totalhours}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  gentableheader(data) {
    if (data) {
      return (
        <Grid>
          <Grid.Column width={7}>
            <Segment>
              <Table selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Employee Number</Table.HeaderCell>
                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                    <Table.HeaderCell>Regular Hours</Table.HeaderCell>
                    <Table.HeaderCell>PTO Hours</Table.HeaderCell>
                    <Table.HeaderCell>Unpaid Hours</Table.HeaderCell>
                    <Table.HeaderCell>Total Hours</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>{this.gentable(data)}</Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
        </Grid>
      );
    }
  }
  getData() {
    if (this.state.startdate && this.state.enddate) {
      console.log("getting data");
      app
        .service("reports")
        .find({
          query: {
            report: "payroll",
            startdate: this.state.startdate,
            enddate: this.state.enddate
          }
        })
        .then(data => {
          if (data !== this.state.payrolldata) {
            this.setState({ payrolldata: data });
          }
        });
    }
  }
  render() {
    var data;

    return (
      <div className="Payroll">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Start Date</Label>
            <Input
              placeholder="Start Date"
              fluid
              type="date"
              value={this.state.startdate}
              onChange={e =>
                this.setState(
                  {
                    startdate: moment(e.target.value).format("YYYY-MM-DD")
                  },
                  () => {
                    this.getData();
                  }
                )
              }
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              icon
              id="deletecontactbutton"
              inverted
              color="green"
              disabled={
                !this.state.payrolldata || !this.state.payrolldata.length
              }
              onClick={() =>
                genexceldownload(
                  "payrollreport: " +
                    this.state.startdate +
                    " - " +
                    this.state.enddate,
                  this.state.payrolldata,
                  [
                    "Employee Number",
                    "Employee Name",
                    "Regular Hours",
                    "PTO Hours",
                    "Unpaid Hours",
                    "Total Hours"
                  ]
                )
              }
            >
              <Icon name="download" />
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select End Date</Label>
            <Input
              placeholder="End Date"
              fluid
              type="date"
              value={this.state.enddate}
              onChange={e =>
                this.setState(
                  {
                    enddate: moment(e.target.value).format("YYYY-MM-DD")
                  },
                  () => {
                    this.getData();
                  }
                )
              }
            />
          </Grid.Column>
          <Grid.Column width={1} />
        </Grid>
        <Divider />
        {this.gentableheader(this.state.payrolldata)}
      </div>
    );
  }
}

export default Payroll;



// WEBPACK FOOTER //
// ./src/components/reports/payroll.js